import 'jquery-migrate';
import $ from 'jquery';
import Modernizr from 'modernizr';
import cookies from 'js-cookie';

const Shared = {
  root: window ? window : {}
};

  /* ******************************************************************************************** */
  /* * Custom Exception Handling                                                                * */
  /* ******************************************************************************************** */
  
  /**
   * Shared Exception Wrapper
   * 
   * @public
   * @this local
   * @param {String} msg The message of the Exception
   * @return {Mixed} A jQuery Object containing a Handle to the DOM Elements specified by the selector
   */
Shared.Exception = function(msg, args) {
  this.name = 'Shared.Exception';
  this.type = Shared.LVL_ERROR;
  this.msg  = msg;
  this.args = args;
};
  

  /* ******************************************************************************************** */
  /* * String/Number Related Methods                                                            * */
  /* ******************************************************************************************** */
  
  /**
   * JavaScript HTML encode - for example, safe for picking up values from HTML attributes and using them to build up HTML via JS
   *  NOT for use within tags such as script, in the context of event handlers, etc. 
   */
Shared.jhe = function(str) {
  return $('<div/>').text(str).html();
};
  
  /**
   * Left Pads a String with a specified character
   * 
   * @public
   * @this local
   * @param {String} str The string to pad with the specified or default character
   * @param {Number} max The max length of the String to Pad to; if the string is greater, return the string
   * @param {String} [padding] The character(s) to pad the string with; default padding is a single space
   * @return {String} The padded string
   */
Shared.lpad = function(str, max, padding) {
  if (padding === undefined) {padding = ' ';}
  return str.length < max ? Shared.lpad(padding + str, max, padding) : str;
};
  
  /**
   * Right Pads a String with a specified character
   *
   * @public
   * @this local
   * @param {String} str The string to pad with the specified or default character
   * @param {Number} max The max length of the String to Pad to; if the string is greater, return the string
   * @param {String} [padding] The character(s) to pad the string with; default padding is a single space 
   * @return {String} The padded string
   */
Shared.rpad = function(str, max, padding) {
  if (padding === undefined) {padding = ' ';}
  return str.length < max ? Shared.rpad(str + padding, max, padding) : str;
};
  
  /**
   * Trims the whitespace from the ends of a String
   *
   * @public
   * @this local
   * @param {String} str The string to trim
   * @return {String} The trimmed string
   */
Shared.trim = function(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

  /**
   * Escapes a Regular Expression String to make it safe
   *   - reference: http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
   *
   * @public
   * @this local
   * @param {String} str The string to be truncated
   * @param {Number} len The max length of the string before truncating
   * @return {String} The truncated string
   */
Shared.truncate = function truncate(str, len){
  if(str.length <= len)
    return str;
  else
          return str.substring(0, len) + "...";
};
  
  /**
   * Fast UUID generator, RFC4122 version 4 compliant.
   * 
   * @public
   * @this local
   * @author Jeff Ward (jcward.com)
   * @license MIT license
   * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
   * @return {String} The Unique ID
   */
Shared.getUUID = function() {
  var lut = []; 
  var d0 = Math.random()*0xffffffff|0;
  var d1 = Math.random()*0xffffffff|0;
  var d2 = Math.random()*0xffffffff|0;
  var d3 = Math.random()*0xffffffff|0;
  for (var i=0; i<256; i++) { lut[i] = (i<16?'0':'')+(i).toString(16); }
  return lut[d0&0xff]+lut[d0>>8&0xff]+lut[d0>>16&0xff]+lut[d0>>24&0xff]+'-'+
              lut[d1&0xff]+lut[d1>>8&0xff]+'-'+lut[d1>>16&0x0f|0x40]+lut[d1>>24&0xff]+'-'+
              lut[d2&0x3f|0x80]+lut[d2>>8&0xff]+'-'+lut[d2>>16&0xff]+lut[d2>>24&0xff]+
              lut[d3&0xff]+lut[d3>>8&0xff]+lut[d3>>16&0xff]+lut[d3>>24&0xff];
};

  /**
   * Returns a random number between min and max
   *
   * @public
   * @this local
   * @param {Number} min The minimum value to be returned
   * @param {Number} max The maximum value to be returned
   * @return {Number} The random number
   */
Shared.random = function(min, max) {
  if (min instanceof Array && min.length === 2) {
    max = min[1];
    min = min[0];
  }
  return Math.random() * (max - min) + min;
};

  
  /* ******************************************************************************************** */
  /* * Object Related Methods                                                                   * */
  /* ******************************************************************************************** */
  
  /**
   * Clean up Object Vars for Easier Usage
   *
   * @public
   * @this local
   * @param {Object} obj The Object to Clean Up
   * @return undefined
   */
Shared.cleanObject = function(obj) {
  $.each(obj, function(key, val) {
    if ($.type(val) === 'object') {
      Shared.cleanObject(val);
    } else {
      if ($.type(val) === 'string') {
        if (/^true$/i.test(val.trim())) { obj[key] = true; }
        if (/^false$/i.test(val.trim())) { obj[key] = false; }
      }
    }
  });
};
  
  /**
   * Extands an existing Class with the Methods from Another Class
   *
   * @public
   * @this local
   * @param {Class} receivingClass The Class to Augment the Methods to
   * @param {Class} givingClasses An array of Classes to Augment the Methods from
   * @return undefined
   */
Shared.augment = function(receivingClass, givingClasses) {
  var i, n, methodName = null;
  for (i = 0, n = givingClasses.length; i < n; i++) {
    for (methodName in givingClasses[i].prototype) {
      if (givingClasses[i].prototype.hasOwnProperty(methodName)) {
        if (!Object.hasOwnProperty(receivingClass.prototype, methodName)) {
          receivingClass.prototype[methodName] = givingClasses[i].prototype[methodName];
        }
      }
    }
  }
};
  

  /* ******************************************************************************************** */
  /* * Browser Related Methods (Shims)                                                          * */
  /* ******************************************************************************************** */

Shared.setCookie = function(itemName, itemValue, options) {
  options = options || {};
  if ($.cookie !== undefined) {
    cookies.set(itemName, itemValue, options);
  }
};

Shared.getCookie = function(itemName) {
  if ($.cookie !== undefined) {
    return cookies.get(itemName);
  }
};
  
  /**
   * Gets the Current Time as a Timestamp
   * 
   * @public
   * @this local
   * @return {Number} Timestamp of Current Time
   */
Shared.getTime = Date.now || function() { return new Date().getTime(); };
  
  /**
   * Parses a Date/Time and returns a Timestamp
   * 
   * @public
   * @this local
   * @param {string} timeStr The formatted string of the date/time
   * @return {Number} Timestamp of Specified Time
   */
Shared.parseTime = function(timeStr) {
  return (new Date(timeStr)).getTime();
};

  /**
   * Executes a Function on the Browsers' Next Event Loop
   * 
   * @public
   * @this local
   * @return undefined
   */
Shared.onNextEventLoop = function(fnHandler, context, delay) {
  return Shared.root.setTimeout($.proxy(fnHandler, context || Shared), delay || 0);
};
  
  /**
   * 
   */
Shared.getComputedBodyStyle = function(prop) {
  function convertUnitsToPxForIE8(value) {
    var PIXEL = /^\d+(px)?$/i;
    if (PIXEL.test(value)) {
      return parseInt(value, 10);
    }

    var style = el.style.left;
    var runtimeStyle = el.runtimeStyle.left;

    el.runtimeStyle.left = el.currentStyle.left;
    el.style.left = value || 0;
    value = el.style.pixelLeft;
    el.style.left = style;
    el.runtimeStyle.left = runtimeStyle;

    return value;
  }

  var el = document.body;
  var retVal = 0;

      // W3C
  if (document.defaultView && document.defaultView.getComputedStyle) {
    retVal = document.defaultView.getComputedStyle(el, null)[prop];
  } 
      // IE8
  else {
    retVal = convertUnitsToPxForIE8(el.currentStyle[prop]);
  } 

  return parseInt(retVal, 10);
};

Shared.triggerFullscreen = function(enable) {
  var $controls = $('.fullscreen-controls');
  var $expand = $controls.find('.fullscreen-open');
  var $unexpand = $controls.find('.fullscreen-close');

  if (enable) {
    $controls.addClass('fullscreen');
    $expand.attr('style','display: none');
    $unexpand.attr('style','display: inline-block');
  } else {
    $controls.removeClass('fullscreen');
    $expand.attr('style','display: inline-block');
    $unexpand.attr('style','display: none');
  }
};
  
  /**
   * Push an Element into Fullscreen Mode (Defaults to the Current Document)
   * 
   * @public
   * @this local
   * @param {Object} element - (Optional) The element to push into Fullscreen Mode
   * @return undefined
   */
Shared.enterFullscreen = function(element) {
  if (element === undefined) {
    element = document.documentElement;
  }
  if (element.requestFullscreen) {
    Shared.triggerFullscreen(true);
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    Shared.triggerFullscreen(true);
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) {
    Shared.triggerFullscreen(true);
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) {
    Shared.triggerFullscreen(true);
    element.msRequestFullscreen();
  } else {
    return false;
  }
};
  
  /**
   * Exit Fullscreen Mode for Current Document and any Elements within
   * 
   * @public
   * @this local
   * @return undefined
   */
Shared.exitFullscreen = function() {
  // For the purposes of this check, we only need to be concerned with these properties.
  // We may have a "fake" fullscreen element, but trying to call exitFullscreen in that case will throw an error.
  var isFullscreen = document.fullscreenElement || 
  document.webkitFullscreenElement || 
  document.mozFullScreenElement
  /** 
   * Chrome & other modern browsers throw errors 
   * if you try to exit fullscreen when you are not in fullscreen mode.
   * */ 
  if (!isFullscreen) {
    return;
  }

  if (document.exitFullscreen) {
    Shared.triggerFullscreen(false);
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    Shared.triggerFullscreen(false);
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    Shared.triggerFullscreen(false);
    document.webkitExitFullscreen();
  } else {
    return false;
  }
};

  /* ******************************************************************************************** */
  /* * Template Rendering Methods                                                               * */
  /* ******************************************************************************************** */
  
  /**
   * Inserts a CSS Resource into the Page
   * 
   * @public
   * @this local
   * @return undefined
   */
Shared.insertCSS = function(url) {
  var ss = document.createElement('link');
  ss.type = 'text/css'; ss.rel = 'stylesheet'; ss.href = url;
  document.getElementsByTagName('head')[0].appendChild(ss);
};
  
  /**
   * Inserts a JS Resource into the Page, and fires a callback once it is loaded
   * 
   * @public
   * @this local
   * @return undefined
   */
Shared.insertJS = function(url, callback) {
  var js = document.createElement('script');
  js.id = 'injected-js-' + Shared.getTime();
  js.async = 0; js.src = url;
  js.onreadystatechange = js.onload = function() {
    var state = js.readyState;
    if (!callback.done && (!state || /loaded|complete/.test(state))) {
      callback.done = true;
      callback.call(null, js.id);
    }
  };
  document.getElementsByTagName('head')[0].appendChild(js);
};
  
  /* ******************************************************************************************** */
  /* * DOM Element Related Methods                                                              * */
  /* ******************************************************************************************** */
  
  /**
   * Gets a Handle to a jQuery DOM Element and caches the Handle
   *      - if the Handle exists in subsequent calls, it returns the cached Handle
   * 
   * @public
   * @this local
   * @param {String} selector A string containing a valid CSS Selector used to find elements in the DOM
   * @return {Mixed} A jQuery Object containing a Handle to the DOM Elements specified by the selector
   */
Shared.$ = function(selector) {
  var $el = null, objs = {'top': top, 'window': window, 'document': document};
  if (typeof selector === 'string') {
    if (Shared.ElementBank[selector] === undefined || Shared.ElementBank[selector].length < 1) {
      if (objs[selector] !== undefined) {
        Shared.ElementBank[selector] = $(objs[selector]);
      } else {
        Shared.ElementBank[selector] = $(selector);
      }
    }
    $el = Shared.ElementBank[selector];
  } else {
    $el = $(selector);
  }
  return $el;
};
  
  /**
   * Scroll the Body Element to a Pixel-Based Coordinate
   *  - Standarized method for Scrolling that works in all Browsers/Devices
   * 
   * @public
   * @this local
   * @param {Number} top - The amount of Pixels to Scroll the Element by; If not supplied, will return the Current Value of "scrollTop"
   * @param {Number} animateSpeed - The speed of the Animation to use; if not set no animation will be used
   * @param {Object} $el - a jQuery Element Handle to the Element to be Scrolled; Defaults to "window"
   * @return undefined
   */
Shared.scrollTop = function(top, animateSpeed, $el) {
      // Ensure Element was Scrolled
      //  - Chrome on Mac has some strange scroll problem
  var ensureScrolling = function() {
    Shared.onNextEventLoop(function() {
      if ($el.scrollTop() !== top && 'scroll' in window) {
        window.scroll(0, top);
      }
    });
  };
      
      // Get Scroll Element
  $el = $el || Shared.$('window');
      // Make sure that object is jquery instance
  $el = $($el);
      
      // Get Scroll-Top of Element
  if (top === undefined || top === null) {
    return $el.scrollTop();
  }
      
      // Perform Scrolling in next Browser Event Loop
  Shared.onNextEventLoop(function() {
    if (animateSpeed && animateSpeed > 0 && $el[0] !== window) {
      $el.animate({'scrollTop': top}, animateSpeed, ensureScrolling);
    } else {
      $el.scrollTop(top);
      ensureScrolling();
    }
  }, this, 10);
};

  /**
   * Animates an Element using CSS3 Transitions or Fallback to jQuery Animations if not supported
   *
   * @public
   * @this local
   * @param {Object} element A jQuery Element to Animate
   * @param {Object} props The Properties of the Element to Animate
   * @param {Number} [duration] The duration of the animation in Milliseconds only
   * @param {Function} [callback] A callback function to execute once the animation has completed
   * @return undefined
   */
Shared.animate = function($element, props, duration, callback) {
  if (Modernizr && Modernizr.csstransitions && $element.transition !== undefined) {
    $element.transition(props, duration, 'in', callback);
  } else {
    $element.animate(props, duration, 'swing', callback);
  }
};
  
  /* ******************************************************************************************** */
  /* * Special Event Registration                                                               * */
  /* *  -- debouncedresize                                                                      * */
  /* ******************************************************************************************** */
  
  /**
   * Register Specialized Global Events
   * 
   *   [
   *      {'event': 'resize', 'prefix': 'debounced', 'threshold': 150}
   *      {'event': 'keyup',  'prefix': 'debounced', 'threshold': 250},
   *   ]
   * 
   * @public
   * @this local
   * @return undefined
   */
Shared.registerSpecialEvents = function(eventsArray) {
  var i, $event = $.event;
  if (!Array.isArray(eventsArray)) { return; }
      
  var specialSetup = function(evd) {
    return function() {
      var $win = $(this);
      if (!$win.data('special-event-init-' + evd.event)) {
        $win.data('special-event-init-' + evd.event, true);
        $win.on(evd.event, evd.$special.handler);
      }
    };
  };
  var specialteardown = function(evd) {
    return function() {
      $(this).off(evd.event, evd.$special.handler);
    };
  };
  var specialHandler = function(evd) {
    return function(event, execAsap) {
              // Save the context
      var context = this,
        args = arguments,
        dispatch = function() {
                      // set correct event type
          event.type = evd.prefix + evd.event;
          $event.dispatch.apply(context, args);
        };

      if (evd.eventTimeout) {
        window.clearTimeout(evd.eventTimeout);
      }

      if (execAsap) { dispatch(); }
      else { evd.eventTimeout = window.setTimeout(dispatch, evd.$special.threshold); }
    };
  };
      
      // Loop through Events Array
  for (i = 0; i < eventsArray.length; i++) {
    var evd = eventsArray[i];
    evd.$special = {};
    evd.eventTimeout = 0;
          
          // Ensure valid Event Data
    if (evd.event === undefined || !evd.event.length) { continue; }
    if (evd.prefix === undefined || !evd.prefix.length) { evd.prefix = 'debounced'; }
    if (evd.threshold === undefined || evd.threshold < 10) { evd.threshold = 150; }
          
          // Avoid registering events twice
    if ($event.special[evd.prefix + evd.event]) { continue; }
          
          // Create Special Event Handler
    evd.$special = $event.special[evd.prefix + evd.event] = {
      'setup'     : specialSetup(evd),
      'teardown'  : specialteardown(evd),
      'handler'   : specialHandler(evd),
      'threshold' : evd.threshold
    };
  }
};

  
  /* ******************************************************************************************** */
  /* * Fixes for 3rd-Party Plugins                                                              * */
  /* ******************************************************************************************** */
  
  // Fix Bindings for Older jQuery
if (typeof $.on !== 'function') { $.on = $.bind; }
  
  
  /* ******************************************************************************************** */
  /* * Private/Static Member Vars                                                               * */
  /* ******************************************************************************************** */
  
  /** @member {Object} ElementBank A bank of Cached jQuery Objects with handles to DOM Elements */
Shared.ElementBank = {};
  
  /** @member {Object} LastXhr A handle to the last Ajax Request made */
Shared.LastXhr = {};

export default Shared;
